import React from 'react';
import { BaseComponent } from '../../../components/BaseComponent';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { PageHeader } from '../../../components/PageHeader';
import { ChevronRight } from '../../../components/Icon';
import { Content } from '../../../components/Content';
import { HBox, VBox } from '../../../components/Box';
import { FormField } from '../../../components/FormFields';
import { Input } from '../../../components/Form';
import { WorkflowProductsOverviewTable } from '../components/WorkflowProductsOverviewTable';
import _ from 'lodash';
import {
  createWorkflow,
  fetchCompanyWorkflow,
  updateWorkflow,
  createCompanyWorkflowTask,
  updateCompanyWorkflowTask,
} from '../actions';
import { selectCompanyWorkflow } from '../selectors';
import { selectConfig, selectWorks } from '../../Api/selectors';
import {
  REQUEST_ADD_WORKFLOW_PRODUCT,
  REQUEST_UPDATE_WORKFLOW_PRODUCT,
  REQUEST_COMPANY_WORKFLOW,
  WORKFLOW_STATUSES,
} from '../constants';
import { Loader } from '../../../components/Loader';
import { fetchAllProducts } from '../../products/actions';
import { selectProducts } from '../../products/selectors';
import { REQUEST_PRODUCTS } from '../../products/constants';
import { WorkflowTasksSection } from '../components/WorkflowTasksSection';
import { COMPANY_CRUD } from '../../../components/Permission/constants';
import { Permission } from '../../../components/Permission';

const Container = styled.div`
  .nav-link {
    cursor: pointer;
  }
  .nav-link.active {
    color: blue;
  }

  .col {
    width: 100%;
  }
  .col-main {
    padding-right: 48px;
  }

  .formField {
    margin-bottom: 12px;
    .label {
      text-transform: capitalize;
      margin-bottom: 6px;
      color: #6c757d;
    }
  }

  .field-block {
    width: 50%;
  }
  .info-card {
    padding: 24px;
    width: auto;
    h2 {
      margin-bottom: 24px;
    }
    .btn {
      margin-right: 6px;
    }
    .col {
      @media (max-width: 768px) {
        width: 100%;
        min-width: 200px;
      }
    }
  }
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: row;

  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }
`;

const STATE = {};

class CompanyWorkflowDetailsComp extends BaseComponent {
  constructor(props) {
    super(props, { ..._.cloneDeep(STATE) });
  }

  componentDidMount() {
    if (this.props.workflow_id) this.props.fetch();
    this.props.fetchAvailableProducts();
  }

  get availableProducts() {
    const added = this.workflowProducts.map(i => i.product.id);
    return this.props.availableProducts.filter(i => !added.includes(i.id));
  }

  get productOptions() {
    return this.availableProducts.map(p => ({ value: p.id, label: p.name }));
  }

  get newProduct() {
    return this.state?.newProduct;
  }

  get workflow() {
    return this.props.workflow;
  }

  get workflowProducts() {
    return this.workflow?.products ?? [];
  }

  get tasks() {
    return (this.workflow?.tasks ?? []).map(t => ({
      ...t,
      vehiclePurposes: t.companyWorkflowTask ? t.companyWorkflowTask.vehiclePurposes : t.vehiclePurposes,
    }));
  }

  getFieldValue(name) {
    if (!this.props.workflow_id) return this.state[name];
    if (!this.workflow) return null;
    return this.state[name] !== undefined ? this.state[name] : this.workflow[name];
  }

  get status() {
    const value = this.getFieldValue('status');
    if (Object.values(WORKFLOW_STATUSES).includes(value)) return value;
    return WORKFLOW_STATUSES.OPEN;
  }

  editTask(id, dto) {
    const task = this.tasks.find(t => t.id === id);
    if (!task.companyWorkflowTask) {
      this.props.addCompanyWorkflowTask(id, dto);
    }

    if (task.companyWorkflowTask) {
      this.props.updateCompanyWorkflowTask(id, task.companyWorkflowTask.id, dto);
    }
  }

  get isFinal() {
    return this.workflow?.status === WORKFLOW_STATUSES.FINAL;
  }

  renderFieldsForExistingWorkflow() {
    if (!this.props.workflow_id) return '';
    return (
      <>
        <HBox>
          <WorkflowProductsOverviewTable
            workflowProducts={this.workflowProducts}
            workflow={this.workflow}
            workflowDisabled
            companyId={this.props.company_id}
          />
        </HBox>
        <HBox left className="field-block">
          <FormField label={this.lbl('workflows.details.tasksSectionTitle')}></FormField>
        </HBox>
        <HBox>
          <WorkflowTasksSection tasks={this.tasks} editTask={this.editTask.bind(this)} />
        </HBox>
      </>
    );
  }

  reset() {
    this.setState(prev => ({ ...STATE }));
  }

  render() {
    if (this.props.work) return <Loader small />;
    return (
      <Permission permission={COMPANY_CRUD}>
        <Container>
          <PageHeader
            title={this.props.workflow_id ? this.lbl('workflows.details.title') : this.lbl('workflows.create.title')}
            breadCrumbs={
              <HBox>
                <span className="nav-link" onClick={() => this.to('/')}>
                  Vindat
                </span>
                <ChevronRight />
                <span className="nav-link" onClick={() => this.to('/workflows')}>
                  {this.lbl('leftBar.workflows')}
                </span>

                <ChevronRight />
                <span className="nav-link active" onClick={() => this.to('/workflows/new')}>
                  {this.props.workflow_id ? this.lbl('workflows.details.title') : this.lbl('workflows.create.title')}
                </span>
              </HBox>
            }
          ></PageHeader>
          <div className="info-card">
            <Content>
              <Wrapper>
                <VBox left className="col col-main">
                  <HBox left className="field-block">
                    <FormField label={this.lbl('workflows.details.name')}>
                      <Input name="name" value={this.getFieldValue('name')} disabled />
                    </FormField>
                  </HBox>
                  <HBox left className="field-block">
                    <FormField label={this.lbl('workflows.details.nameOnInvoice')}>
                      <Input name="nameOnInvoice" value={this.getFieldValue('nameOnInvoice')} disabled />
                    </FormField>
                  </HBox>
                  <HBox left className="field-block">
                    <FormField label={this.lbl('workflows.details.status')}>
                      <p>{this.lbl(`workflows.details.status.${this.status}`)}</p>
                    </FormField>
                  </HBox>
                  {this.renderFieldsForExistingWorkflow()}
                </VBox>
              </Wrapper>
            </Content>
          </div>
        </Container>
      </Permission>
    );
  }
}

CompanyWorkflowDetailsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    workflow: selectCompanyWorkflow(),
    work: selectWorks([
      REQUEST_COMPANY_WORKFLOW,
      REQUEST_PRODUCTS,
      REQUEST_ADD_WORKFLOW_PRODUCT,
      REQUEST_UPDATE_WORKFLOW_PRODUCT,
    ]),
    availableProducts: selectProducts(),
    config: selectConfig(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    create(dto, callback) {
      dispatch(createWorkflow(dto, callback));
    },
    fetch() {
      dispatch(fetchCompanyWorkflow(ownProps.company_id, ownProps.workflow_id));
    },
    update(dto, callback) {
      dispatch(updateWorkflow(ownProps.workflow_id, dto, callback));
    },
    fetchAvailableProducts() {
      dispatch(fetchAllProducts());
    },
    addCompanyWorkflowTask(taskId, dto) {
      dispatch(createCompanyWorkflowTask(ownProps.company_id, ownProps.workflow_id, taskId, dto));
    },
    updateCompanyWorkflowTask(taskId, companyTaskId, dto) {
      dispatch(updateCompanyWorkflowTask(ownProps.company_id, ownProps.workflow_id, taskId, companyTaskId, dto));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export const CompanyWorkflowDetails = compose(withConnect, withRouter)(CompanyWorkflowDetailsComp);
